import { action } from 'typesafe-actions';
import { FailToastMeta, IPOSCategories, IPOSEmployees } from 'types';
import { POS } from './types';

export const getPosCategoriesRequest = (siteId: string) => action(POS.GET_POS_CATEGORIES_REQUEST, { siteId });
export const getPosCategoriesSuccess = (response: IPOSCategories) => action(POS.GET_POS_CATEGORIES_SUCCESS, response);
export const getPosCategoriesError = (error: any, failToast?: FailToastMeta) => action(POS.GET_POS_CATEGORIES_FAIL, error, { failToast });

export const getPosEmployeesRequest = (siteId: string) => action(POS.GET_POS_EMPLOYEES_REQUEST, { siteId });
export const getPosEmployeesSuccess = (response: IPOSEmployees) => action(POS.GET_POS_EMPLOYEES_SUCCESS, response);
export const getPosEmployeesError = (error: any, failToast?: FailToastMeta) => action(POS.GET_POS_EMPLOYEES_FAIL, error, { failToast });
